<template>
  <vx-input-group class="mb-0 date-picker-container" prependClasses="border border-solid border-grey border-r-0" appendClasses="date-remove-btn border border-solid border-grey border-l-0 ">
    <template slot="prepend">
      <div class="prepend-text text-center">
        <feather-icon icon="CalendarIcon" svgClasses="stroke-current w-5 h-5" />
      </div>
    </template>
    <datepicker :inputClass="(!removeDeleteButton) ? 'border-r-0' : ''" :placeholder="placeholder" :value="model" :format="customFormatter" @selected="selected"></datepicker>
    <template slot="append" v-if="!removeDeleteButton">
      <div class="append-text text-center" @click="selected('')">
        <feather-icon icon="XIcon" svgClasses="stroke-current w-4 h-4" />
      </div>
    </template>
  </vx-input-group>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Moment from 'moment'

export default {
  name: 'DatePicker',
  components: {
    Datepicker
  },
  props: {
    model: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    removeDeleteButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    customFormatter (date) {
      return Moment(date).format('YYYY-MM-DD')
    },
    selected (val) {
      if (val === '') {
        this.$emit('input', '')
      } else {
        this.$emit('input', Moment(val).format('YYYY-MM-DD'))
      }
    }
  }
}
</script>

<style>
.date-remove-btn {
  cursor: pointer;
}
</style>
